module.exports = __webpack_public_path__ + "img/43-white.8a7eac78.svg";